import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { TranslatorService } from '../../services/TranslatorService';
import { Organization } from '../../interfaces/Organization';

interface ServiceFormProps {
  service: Organization;
  title?: string;
}

const ServiceForm: React.FC<ServiceFormProps> = ({ service, title }) => {
  const translatorService = new TranslatorService();

  return (
    <Box style={{ width: '100%' }}>
      <Typography variant="h5" style={{ marginBottom: '10px', marginTop: 16, textAlign: 'left' }}>
        {title ?? translatorService.Tranlate('APPOINTMENT_SERVICE_TITLE', 'Service')}
      </Typography>
      <Box
        px={1}
        style={{
          border: '2px solid var(--primary)',
          borderRadius: 10,
          padding: 8,
          borderWidth: 2,
          display: 'flex',
          flexDirection: 'column',
          height: '90%'
        }}
      >
        <Typography align="left">{`${translatorService.Tranlate('EDIT_ORGANIZATION_NAME_LABEL', 'Nume')}: ${service.name || ''}`}</Typography>
        <Typography align="left">{`${translatorService.Tranlate('EDIT_ORGANIZATION_ADDRESS_LABEL', 'Adresa')}: ${service.address || ''}`}</Typography>
        <Typography align="left">{`${translatorService.Tranlate('EDIT_ORGANIZATION_PHONE_LABEL', 'Telefon')}: ${service.phone || ''}`}</Typography>
        <Typography align="left">{`${translatorService.Tranlate('EDIT_ORGANIZATION_EMAIL_LABEL', 'E-mail')}: ${service.email || ''}`}</Typography>
      </Box>
    </Box>
  );
};

export default ServiceForm;
